<div
  *ngIf="!is_list_running"
  class="sp-width__full sp-height__full sp-background__accent-contrast sp-border-radius__s sp-padding__x2">
  <app-home-header
    icon="apartment"
    [title]="'COMPANIES.SUMMARY_PENDING_EVALUATION_LABEL'"
    (refresh)="refresh.emit()"
    (see_all)="onSeeAllClick()"></app-home-header>

  <div
    *ngFor="let company of companies"
    class="sp-padding__vert sp-width__full">
    <app-home-companies-item
      [company]="company"
      (refresh)="refresh.emit()"></app-home-companies-item>
  </div>

  <div
    *ngIf="!companies?.length"
    class="sp-margin__top-x2">
    <app-shared-empty-message [empty_message]="'COMPANIES.EMPTY_MESSAGE'"></app-shared-empty-message>
  </div>
</div>

<div
  *ngIf="is_list_running"
  class="sp-width__full sp-height__full">
  <app-loading [card_radius]="'sp-border-radius__s'"></app-loading>
</div>
